import React, { useMemo } from 'react';
import { Card, Row, Col, Typography, Space } from 'antd';
import { Link } from 'react-router-dom';
import { getServiceCards, menuConfig } from '../../data/menuConfig';

const { Title, Paragraph } = Typography;

interface DynamicHomePageProps {
  showServiceCards?: boolean;
  maxCardsPerRow?: number;
}

const DynamicHomePage: React.FC<DynamicHomePageProps> = ({
  showServiceCards = true,
  maxCardsPerRow = 4
}) => {
  // 使用 useMemo 确保数据变化时重新计算
  const services = useMemo(() => getServiceCards(), []);

  // 计算响应式列数
  const getColSpan = () => {
    const totalServices = services.length;
    const cardsPerRow = Math.min(maxCardsPerRow, totalServices);
    return 24 / cardsPerRow;
  };

  return (
    <div style={{ maxWidth: 1200, margin: '0 auto' }}>
      {/* 标题和描述 */}
      <div style={{ textAlign: 'center', marginBottom: 40 }}>
        <Title level={2} style={{ marginBottom: 20 }}>生物信息学计算服务平台</Title>
        <Paragraph style={{ fontSize: 16 }}>
          提供多种生物信息学计算服务，包括蛋白质分析、抗体分析、序列处理和结构设计等功能
        </Paragraph>
        <Paragraph type="secondary" style={{ fontSize: 14 }}>
          当前平台包含 {menuConfig.length - 1} 个主要服务模块
        </Paragraph>
      </div>


      {/* 服务导航卡片 */}
      {showServiceCards && services.length > 0 && (
        <>
          <Title level={3} style={{ marginBottom: 24 }}>
            服务导航 ({services.length}个服务)
          </Title>
          <Row gutter={[24, 24]}>
            {services.map((service, index) => (
              <Col 
                xs={24} 
                sm={12} 
                md={getColSpan()} 
                lg={getColSpan()} 
                key={service.link}
              >
                <Link to={service.link} style={{ textDecoration: 'none' }}>
                  <Card 
                    hoverable 
                    style={{ height: '100%', transition: 'all 0.3s' }}
                    styles={{ 
                      header: { 
                        backgroundColor: service.color, 
                        color: '#fff',
                        borderRadius: '8px 8px 0 0'
                      } 
                    }}
                    title={
                      <Space>
                        {service.icon}
                        <span>{service.title}</span>
                      </Space>
                    }
                  >
                    <Paragraph style={{ margin: 0, color: '#666' }}>
                      {service.description}
                    </Paragraph>
                    <div style={{ 
                      marginTop: 8, 
                      fontSize: 12, 
                      color: service.color,
                      fontWeight: 'bold'
                    }}>
                      {service.category === 'analysis' ? '分析服务' : '设计服务'}
                    </div>
                  </Card>
                </Link>
              </Col>
            ))}
          </Row>
        </>
      )}

      {/* 平台信息 */}
      <div style={{ 
        marginTop: 40, 
        padding: 20, 
        backgroundColor: '#f5f5f5', 
        borderRadius: 8,
        textAlign: 'center'
      }}>
        <Paragraph style={{ margin: 0, color: '#666' }}>
          平台持续更新中，更多功能模块正在开发...
        </Paragraph>
      </div>
    </div>
  );
};

export default DynamicHomePage; 